<template>
    <div>
        <section class="block vacancy-detail">
            <div class="container">
                <div class="row mb-3">
                    <div
                        class="col-12"
                        :style="titleStyle"
                        v-html="mergedText"
                    ></div>
                </div>
                <div class="row">
                    <div class="col-12 text-left">
                        <a
                            class="btn btn-primary mr-1 vacancy__btn"
                            :href="careersApplyUrl"
                            target="_blank"
                            >Solliciteren</a
                        >
                    </div>
                </div>
            </div>
        </section>
        <section class="block vacancy-detail fixed-top">
            <div class="container">
                <div class="vacancy__intro row pt-1 pt-md-0">
                    <div ref="title" class="col-6 col-md-8">
                        <h1 class="h2">{{ title }}</h1>
                    </div>
                    <div class="col-6 col-md-4">
                        <a
                            class="btn btn-primary mr-1 vacancy__btn mb-1"
                            :href="careersApplyUrl"
                            target="_blank"
                            >Solliciteren</a
                        >
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            default() {
                return '';
            }
        },
        mergedText: {
            type: String,
            default() {
                return '';
            }
        },
        careersApplyUrl: {
            type: String,
            default() {
                return '';
            }
        }
    },

    data() {
        return {
            titleStyle: {}
        };
    },
    created() {
        window.addEventListener('resize', this.calcHeader);
    },
    destroyed() {
        window.removeEventListener('resize', this.calcHeader);
    },
    mounted() {
        this.calcHeader();
    },
    methods: {
        calcHeader() {
            this.titleStyle = {
                paddingTop: this.$refs.title.clientHeight + 'px'
            };
        }
    }
};
</script>

<style lang="scss" scoped></style>
